<template>
    <div>
        <div class="pro-table">
            <div class="row">
                <div class="col-md-12">
                    <div class="position-relative">
                        <div v-if="loader" class="content-loader">
                            <i class="fas fa-spinner fa-pulse fa-3x" aria-hidden="true"></i>
                        </div>
                        <vue-good-table :columns="columns" :rows="productsData"
                                        :pagination-options="{ enabled: true, mode: 'records'}"
                                        :search-options="{enabled: true}"
                                        styleClass="vgt-table bordered">
                            <template slot="table-row" slot-scope="props">
                                                                <span v-if="props.column.field == 'name'">
                                                                    <span><a
                                                                            :href="baseUrl+'/product/'+props.row.name">{{props.row.name}}</a></span>
                                                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {VueGoodTable} from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css'


    export default {
        components: {
            VueGoodTable
        },
        props: ['products'],
        data: function () {
            return {
                columns: [
                    {
                        label: 'Name',
                        field: 'name',

                    },
                    {
                        label: 'Description',
                        field: 'description',
                    },
                    {
                        label: 'Material Grade',
                        field: 'material_grade',
                    },

                ],
                loader: null,
            }
        },
        methods: {


            getData() {

                // let that = this;
                // console.log(process.env.MIX_API_URL);
                // this.loader = true;
                // axios.get(process.env.MIX_API_URL + '/category/' + this.categoryId)
                //     .then(function (response) {
                //         console.log(response.data);
                //         that.columns = response.data.columns;
                //         that.rows = response.data.rows;
                //         that.filters = response.data.filters;
                //         that.loader = null;
                //     })
                //     .catch(function (error) {
                //         console.log(error);
                //     })
                //     .then(function () {
                //     });


            },
        },
        mounted: function () {
            this.getData();
        },
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            baseUrl: function () {
                return window.location.href;
            },
            productsData: function () {
                return JSON.parse(this.products);
            }
        },
        filters: {}
    }

</script>
